import timeTracking from '$$timeTrackingModel';

function onTaskTimeLogsCreated(event) {
  const items = event.innerSettings.collaborationItems;
  const gantt_id = event.innerSettings.gantt_id;

  timeTracking.manualUpdateItemForTask({
    task_id: event.data.timeLogs[0].taskId,
    gantt_id,
  }, items);
}

export default onTaskTimeLogsCreated;
